(function () {
    var MODAL_SELECTOR = '#search-modal';
    var PRODUCT_ITEM_SELECTOR = '.snize-product';
    var PROCESSED_ATTR = 'data-searchanise-slide';
    var WRAP_CLASS = 'searchanise-slider';
    var TRACK_CLASS = 'searchanise-slider__track';
    var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

    function isMobileViewport() {
      return MOBILE_MQ.matches;
    }

    /** Restore Searchanise's native product list (no horizontal track). */
    function unwrapSliders(modal) {
      if (!modal) return;
      modal.querySelectorAll('.' + WRAP_CLASS).forEach(function (wrap) {
        var track = wrap.querySelector('.' + TRACK_CLASS);
        if (!track) {
          wrap.remove();
          return;
        }
        var host = wrap.parentElement;
        if (!host) {
          wrap.remove();
          return;
        }
        Array.from(track.children).forEach(function (slide) {
          slide.removeAttribute(PROCESSED_ATTR);
          host.insertBefore(slide, wrap);
        });
        wrap.remove();
      });
    }

    /* Find the lowest common ancestor (LCA) of all product cards and the list */
    function findSlides(root) {
      if (!root) return null;
      var cards = root.querySelectorAll(PRODUCT_ITEM_SELECTOR);
      if (cards.length < 2) return null;

      var lca = cards[0].parentElement;
      for (var i = 1; i < cards.length; i++) {
        while (lca && !lca.contains(cards[i])) lca = lca.parentElement;
      }
      if (!lca) return null;

      var slides = [];
      for (var j = 0; j < lca.children.length; j++) {
        var child = lca.children[j];
        if (/view\s+all|see\s+all/i.test(child.textContent || '')) continue;
        if (child.matches('.snize-view-all-link, .snize-view-all, a[class*="view-all"]')) {
          continue;
        }
        if (child.querySelector('.snize-view-all-link, a[class*="view-all"]')) continue;
        if (
          child.matches(PRODUCT_ITEM_SELECTOR) ||
          child.querySelector(PRODUCT_ITEM_SELECTOR)
        ) {
          slides.push(child);
        }
      }
      if (slides.length < 2) return null;

      return { host: lca, slides: slides };
    }

    function wrapAsSlider(host, slides) {
      if (!host || !slides || slides.length < 2) return;

      // Build fresh track + wrap so unrelated siblings (titles, view-all, etc.)
      // stay exactly where Searchanise placed them.
      var wrap = document.createElement('div');
      wrap.className = WRAP_CLASS;

      var track = document.createElement('div');
      track.className = TRACK_CLASS;
      wrap.appendChild(track);

      // Insert the wrap at the position of the first slide, then move every
      // slide into the track. Everything else (labels, footers) stays in host.
      host.insertBefore(wrap, slides[0]);
      slides.forEach(function (slide) {
        slide.setAttribute(PROCESSED_ATTR, 'true');
        track.appendChild(slide);
      });

      // Inject arrow buttons from the template.
      var tpl = document.getElementById('searchanise-slider-arrows-template');
      if (tpl && tpl.content) {
        wrap.appendChild(tpl.content.cloneNode(true));
      }

      var prev = wrap.querySelector('.searchanise-slider__arrow--prev');
      var next = wrap.querySelector('.searchanise-slider__arrow--next');

      function stepWidth() {
        var first = track.querySelector('[' + PROCESSED_ATTR + ']');
        if (!first) return track.clientWidth * 0.8;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= max;
        var overflows = track.scrollWidth > track.clientWidth + 1;

        wrap.classList.toggle('searchanise-slider--no-overflow', !overflows);
        prev.toggleAttribute('disabled', atStart || !overflows);
        next.toggleAttribute('disabled', atEnd || !overflows);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -stepWidth(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: stepWidth(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);

      // Initial state (deferred to allow Searchanise layout to settle).
      requestAnimationFrame(updateArrows);
      setTimeout(updateArrows, 200);
    }

    function tryWrap() {
      var modal = document.querySelector(MODAL_SELECTOR);
      if (!modal) return;

      if (isMobileViewport()) {
        unwrapSliders(modal);
        return;
      }

      var cards = modal.querySelectorAll(PRODUCT_ITEM_SELECTOR);
      if (cards.length < 2) return;

      // Already wrapped: every live product card sits inside a track.
      // This is a structural check (not an attribute on the host), so it
      // stays correct even when Searchanise re-renders between modal opens.
      var trackSelector = '.' + TRACK_CLASS;
      var allInTrack = true;
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].closest(trackSelector)) {
          allInTrack = false;
          break;
        }
      }
      if (allInTrack) return;

      // Searchanise re-renders may leave an empty .searchanise-slider behind
      // (arrows but no products). Remove it before building a new one —
      // otherwise we end up with ghost arrows stacked next to the real slider.
      var staleWraps = modal.querySelectorAll('.' + WRAP_CLASS);
      for (var s = 0; s < staleWraps.length; s++) {
        if (!staleWraps[s].querySelector(PRODUCT_ITEM_SELECTOR)) {
          staleWraps[s].remove();
        }
      }

      var found = findSlides(modal);
      if (!found) return;
      wrapAsSlider(found.host, found.slides);
    }

    // Watch the modal subtree — Searchanise re-renders on every keystroke.
    function startObserver() {
      var modal = document.querySelector(MODAL_SELECTOR);
      if (!modal) return false;

      tryWrap();

      var obs = new MutationObserver(function () {
        tryWrap();
      });
      obs.observe(modal, { childList: true, subtree: true });
      return true;
    }

    if (!startObserver()) {
      document.addEventListener('DOMContentLoaded', startObserver, { once: true });
    }

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', function () {
        var modal = document.querySelector(MODAL_SELECTOR);
        if (!modal) return;
        if (isMobileViewport()) {
          unwrapSliders(modal);
        } else {
          tryWrap();
        }
      });
    }
  })();
